// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class DeviceRegisterResource extends Resource {
    basePath: string = 'devices/unregister/';

    objectPath: string = 'devices/unregister/{ident}/';
}
